<script setup lang="ts">
import { getCurrentInstance } from 'vue';

import type { Selection } from '@/types/configuration';

import TheRDBKList from '@/components/roadbook/TheRDBKList.vue';
import { i18n } from '@/shared-instance';
import { useFiltersStore } from '@/stores/useFiltersStore';

const props = defineProps<{ selection: string }>();
const filtersStore = useFiltersStore();
i18n.install(getCurrentInstance()!.appContext.app);

const taxonomies: Selection | null = props.selection ? JSON.parse(props.selection) : null;
if (taxonomies && taxonomies.taxonomies.length) {
  filtersStore.setListSelectionPreset(taxonomies.taxonomies);
}
else {
  throw new Error('selection for roadbook component is missing.');
}
</script>

<template>
  <TheRDBKList />
</template>
